export enum CallQueue {
  Inbound = 1,
  Outbound = 2,
  Queue = 3
}
